export default function HeroSection() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center">
      <div className="absolute inset-0 bg-white">
        <img 
          src="https://static.readdy.ai/image/2c68e7d7a9374e6fb32ca95eed89f386/5740bf83f97888275933fbe9cdea7a57.jpeg"
          alt="ITEC Groupe Team"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 container mx-auto px-6 py-32 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
          Notre ADN
        </h1>
      </div>
    </section>
  );
}